"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.takeProfitStopLoss = exports.subscribeToFuturesPositionEvents = exports.requestPositionHistory = exports.requestOpenPositions = exports.receivePositionHistory = exports.receiveOpenPositions = exports.getFuturesPositionHistory = exports.getFuturesOpenPositions = exports.closeFuturesPositionByMarket = exports.closeFuturesPositionByLimit = exports.UPDATE_FUTURES_POSITION = exports.REQUEST_POSITION_HISTORY = exports.REQUEST_OPEN_POSITIONS = exports.RECEIVE_POSITION_HISTORY = exports.RECEIVE_OPEN_POSITIONS = void 0;
var _apiActions = require("../../actions/apiActions");
var _snackbarActions = require("../../actions/snackbarActions");
var _FuturesPositionSubscriptionService = _interopRequireDefault(require("../services/FuturesPositionSubscriptionService"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var REQUEST_OPEN_POSITIONS = exports.REQUEST_OPEN_POSITIONS = 'REQUEST_OPEN_POSITIONS';
var RECEIVE_OPEN_POSITIONS = exports.RECEIVE_OPEN_POSITIONS = 'RECEIVE_OPEN_POSITIONS';
var REQUEST_POSITION_HISTORY = exports.REQUEST_POSITION_HISTORY = 'REQUEST_POSITION_HISTORY';
var RECEIVE_POSITION_HISTORY = exports.RECEIVE_POSITION_HISTORY = 'RECEIVE_POSITION_HISTORY';
var UPDATE_FUTURES_POSITION = exports.UPDATE_FUTURES_POSITION = 'UPDATE_FUTURES_POSITION';
var requestOpenPositions = exports.requestOpenPositions = function requestOpenPositions() {
  return {
    type: REQUEST_OPEN_POSITIONS
  };
};
var receiveOpenPositions = exports.receiveOpenPositions = function receiveOpenPositions(payload) {
  return {
    type: RECEIVE_OPEN_POSITIONS,
    payload: payload
  };
};
var getFuturesOpenPositions = exports.getFuturesOpenPositions = function getFuturesOpenPositions(AccountId, OMSId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
      var _yield$dispatch, positions, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            dispatch(requestOpenPositions());
            _context.n = 1;
            return dispatch((0, _apiActions.callAPI)("GetFuturesAccountOpenPositions", {
              AccountId: AccountId,
              OMSId: OMSId
            }));
          case 1:
            _yield$dispatch = _context.v;
            positions = _yield$dispatch.Result;
            if (positions.length === 0 || positions.length > 0) {
              dispatch(receiveOpenPositions(positions));
            } else {
              console.error('GetFuturesAccountOpenPositions error: ', positions.errormsg);
              dispatch((0, _snackbarActions.showSnack)({
                id: 'getFuturesOpenPositionsError',
                text: positions.errormsg,
                type: 'warning'
              }));
            }
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            console.error('GetFuturesAccountOpenPositions error: ', _t);
            dispatch((0, _snackbarActions.showSnack)({
              id: 'getFuturesOpenPositionsError',
              text: _t.message || 'An unexpected error occurred',
              type: 'warning'
            }));
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
var requestPositionHistory = exports.requestPositionHistory = function requestPositionHistory() {
  return {
    type: REQUEST_POSITION_HISTORY
  };
};
var receivePositionHistory = exports.receivePositionHistory = function receivePositionHistory(payload) {
  return {
    type: RECEIVE_POSITION_HISTORY,
    payload: payload
  };
};
var getFuturesPositionHistory = exports.getFuturesPositionHistory = function getFuturesPositionHistory(AccountId, OMSId, startDate, endDate) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      var _yield$dispatch2, positionHistory, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            dispatch(requestPositionHistory());
            _context2.n = 1;
            return dispatch((0, _apiActions.callAPI)('GetFuturesAccountPositionHistory', _objectSpread(_objectSpread({
              AccountId: AccountId,
              OMSId: OMSId
            }, startDate && {
              startDate: startDate
            }), endDate && {
              endDate: endDate
            })));
          case 1:
            _yield$dispatch2 = _context2.v;
            positionHistory = _yield$dispatch2.Result;
            if (positionHistory.length === 0 || positionHistory.length > 0) {
              dispatch(receivePositionHistory(positionHistory));
            } else {
              console.error('GetFuturesAccountPositionHistory error: ', positionHistory.errormsg);
              dispatch((0, _snackbarActions.showSnack)({
                id: 'getFuturesPositionHistoryError',
                text: positionHistory.errormsg,
                type: 'warning'
              }));
            }
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            _t2 = _context2.v;
            console.error('GetFuturesAccountPositionHistory error: ', _t2);
            dispatch((0, _snackbarActions.showSnack)({
              id: 'getFuturesPositionHistoryError',
              text: _t2.message || 'An unexpected error occurred',
              type: 'warning'
            }));
          case 3:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2]]);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var subscribeToFuturesPositionEvents = exports.subscribeToFuturesPositionEvents = function subscribeToFuturesPositionEvents(AccountId) {
  return function (dispatch) {
    _FuturesPositionSubscriptionService["default"].subscribe(function (position) {
      // Handle various position events
      if (position.PositionState === 'Closed' && position.ChangeReason === 'Liquidation') {
        dispatch((0, _snackbarActions.showSnack)({
          id: 'liquidationPositionSnack',
          text: "Your ".concat(position.InstrumentSymbol, " position has been liquidated."),
          type: 'warning'
        }));
      }
      if (position.PositionState === 'Closed' && (position.ChangeReason === 'CloseOperation' || position.ChangeReason === 'UserClosed')) {
        dispatch((0, _snackbarActions.showSnack)({
          id: 'closeFuturesPositionSuccessSnack',
          text: "Position ".concat(position.InstrumentSymbol, " closed"),
          type: 'success'
        }));
      }

      // Update position in state if it belongs to the current account
      if (position.AccountId === AccountId) {
        dispatch({
          type: UPDATE_FUTURES_POSITION,
          payload: position
        });
      }
    });
  };
};
var takeProfitStopLoss = exports.takeProfitStopLoss = function takeProfitStopLoss(_ref3) {
  var AccountId = _ref3.AccountId,
    PositionId = _ref3.PositionId,
    InstrumentId = _ref3.InstrumentId,
    TakeProfitStopLossMode = _ref3.TakeProfitStopLossMode,
    PositionIndex = _ref3.PositionIndex,
    TakeProfitPrice = _ref3.TakeProfitPrice,
    StopLossPrice = _ref3.StopLossPrice,
    TakeProfitTriggerByType = _ref3.TakeProfitTriggerByType,
    StopLossTriggerByType = _ref3.StopLossTriggerByType;
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(dispatch) {
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            _context3.n = 1;
            return dispatch((0, _apiActions.callAPI)('SetTakeProfitStopLoss', {
              AccountId: AccountId,
              PositionId: PositionId,
              InstrumentId: InstrumentId,
              TakeProfitStopLossMode: TakeProfitStopLossMode,
              PositionIndex: PositionIndex,
              TakeProfitPrice: TakeProfitPrice,
              StopLossPrice: StopLossPrice,
              TakeProfitTriggerByType: TakeProfitTriggerByType,
              StopLossTriggerByType: StopLossTriggerByType
            })).then(function (res) {
              if (res.result === false) {
                dispatch((0, _snackbarActions.showSnack)({
                  id: 'takeProfitStopLossErrorSnack',
                  text: "There was an error while trying to set TP/SL. Error Details: ".concat(res.errormsg) || 'An unexpected error occurred while setting TP/SL',
                  type: 'warning'
                }));
              } else {
                dispatch((0, _snackbarActions.showSnack)({
                  id: 'takeProfitStopLossSuccess',
                  text: 'Take Profit and Stop Loss successfully set.',
                  type: 'success'
                }));
              }
            });
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    return function (_x3) {
      return _ref4.apply(this, arguments);
    };
  }();
};
var closeFuturesPositionByLimit = exports.closeFuturesPositionByLimit = function closeFuturesPositionByLimit(position, values, mode) {
  return /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(dispatch, getState) {
      var _state$futures$accoun, state, futuresAccountId, Side, amount, isClosingFullPosition, orderParams, response, errorDetails, _t3;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            _context4.p = 0;
            state = getState();
            futuresAccountId = ((_state$futures$accoun = state.futures.accountInfo.accountInfo) === null || _state$futures$accoun === void 0 ? void 0 : _state$futures$accoun.AccountId) || position.AccountId;
            Side = position.PositionType === 'Long' ? 'Sell' : 'Buy';
            amount = parseFloat(values.amount); // Check if closing 100% of the position with a small tolerance for floating-point rounding issues
            isClosingFullPosition = Math.abs(amount - position.PositionSize) < 0.00000001;
            orderParams = {
              AccountId: futuresAccountId,
              InstrumentId: position.InstrumentId,
              Side: Side,
              // opposite side to close the position
              Quantity: amount,
              OrderType: mode,
              ReduceOnly: !(isClosingFullPosition && mode === 'Market') // Set ReduceOnly to false only when closing 100% of position by market order
            };
            if (mode === 'Limit') {
              orderParams.LimitPrice = parseFloat(values.closingPrice);

              // If the post option is selected
              if (values.post) {
                orderParams.TimeInForce = 'GTC'; // Good Till Cancelled
              }
            }
            _context4.n = 1;
            return dispatch((0, _apiActions.callAPI)('CreateFuturesOrder', orderParams));
          case 1:
            response = _context4.v;
            if (!(response.result === false || response.status === 'Rejected')) {
              _context4.n = 2;
              break;
            }
            errorDetails = response.errormsg || 'Unknown error';
            return _context4.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'closeFuturesPositionByLimitError',
              text: "Failed to close ".concat(position.PositionType, " ").concat(position.InstrumentSymbol, " position. Error: ").concat(errorDetails),
              type: 'warning'
            })));
          case 2:
            return _context4.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'closeFuturesPositionByLimitSuccess',
              text: "Successfully submitted order to close your ".concat(position.PositionType, " ").concat(position.InstrumentSymbol, " position."),
              type: 'success'
            })));
          case 3:
            _context4.n = 5;
            break;
          case 4:
            _context4.p = 4;
            _t3 = _context4.v;
            console.error('closeFuturesPositionByLimit error:', _t3);
            return _context4.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'closeFuturesPositionByLimitError',
              text: "An unexpected error occurred when closing position: ".concat(_t3.message || 'Unknown error'),
              type: 'warning'
            })));
          case 5:
            return _context4.a(2);
        }
      }, _callee4, null, [[0, 4]]);
    }));
    return function (_x4, _x5) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var closeFuturesPositionByMarket = exports.closeFuturesPositionByMarket = function closeFuturesPositionByMarket(position) {
  return /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(dispatch, getState) {
      var _state$futures$accoun2, state, futuresAccountId, closeParams, response, errorDetails, _t4;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            _context5.p = 0;
            state = getState();
            futuresAccountId = ((_state$futures$accoun2 = state.futures.accountInfo.accountInfo) === null || _state$futures$accoun2 === void 0 ? void 0 : _state$futures$accoun2.AccountId) || position.AccountId;
            closeParams = {
              AccountId: futuresAccountId,
              PositionId: position.PositionId
            };
            _context5.n = 1;
            return dispatch((0, _apiActions.callAPI)('CloseFuturesPosition', closeParams));
          case 1:
            response = _context5.v;
            if (!(response.result === false)) {
              _context5.n = 2;
              break;
            }
            errorDetails = response.errormsg || 'Unknown error';
            return _context5.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'closeFuturesPositionByMarketError',
              text: "Failed to close ".concat(position.PositionType, " ").concat(position.InstrumentSymbol, " position. Error: ").concat(errorDetails),
              type: 'warning'
            })));
          case 2:
            return _context5.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'closeFuturesPositionByMarketSuccess',
              text: "Successfully submitted order to close your ".concat(position.PositionType, " ").concat(position.InstrumentSymbol, " position."),
              type: 'success'
            })));
          case 3:
            _context5.p = 3;
            _t4 = _context5.v;
            console.error('closeFuturesPositionByMarket error:', _t4);
            return _context5.a(2, dispatch((0, _snackbarActions.showSnack)({
              id: 'closeFuturesPositionByMarketError',
              text: "An unexpected error occurred when closing position: ".concat(_t4.message || 'Unknown error'),
              type: 'warning'
            })));
        }
      }, _callee5, null, [[0, 3]]);
    }));
    return function (_x6, _x7) {
      return _ref6.apply(this, arguments);
    };
  }();
};